import { ReactNode } from "react";
import { ChevronDoubleRightIcon } from "@heroicons/react/24/outline";
import { DrawerProps as AntDDrawerProps } from "antd";
import { Drawer } from "./Drawer";

export type SidebarProps = AntDDrawerProps & {
  closeIconComponent?: ReactNode;
};

export const Sidebar = ({ closeIconComponent, ...props }: SidebarProps) => (
  <Drawer
    closeIcon={closeIconComponent ?? <ChevronDoubleRightIcon width={20} />}
    {...props}
  />
);
